/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.1.5
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

export enum EGTMWidgetOrderInquiriesTab {
    inquiries = 'Обращения',
    orders = 'Заказы',
}

export const clickTabWidgetOrderInquiries = (tab: EGTMWidgetOrderInquiriesTab): IGTMOperation => ({
    'event': 'addEvents_useNavigations',
    'event_id': 'd-v217-e19',
    'event_cat': 'Заказы и обращения / Tabs',
    'event_name': 'clickLinks',
    'event_param': tab,
});

export const clickLinkOrderOrInquiryWidgetOrderInquiries =
    (link: string, tab: EGTMWidgetOrderInquiriesTab): IGTMOperation => ({
        'event': 'addEvents_makeActions',
        'event_id': 'd-v217-e20',
        'event_cat': 'Заказы и обращения',
        'event_name': 'clickElement',
        'event_param': `${tab} / ${link}`,
    });

export const clickLinkOrderOrInquiryWidgetDownloadFile = (name: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e21',
    'event_cat': 'Заказы и обращения',
    'event_name': 'clickElement',
    'event_param': `Заказы / ${name} / download file`,
});
